import LogoutCallback from './LogoutCallback';

export default LogoutCallback;
